import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {

  transform(value?: string): string {
    const stringToSend = value ? value.split(';').join(", ") : '';


    return stringToSend;
  }

}
